var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".calendar-day[data-v-b0ffa14a]{position:relative;box-sizing:border-box;width:150px}.calendar-day__head[data-v-b0ffa14a]{margin-bottom:3px}.calendar-day__card[data-v-b0ffa14a]{width:100%!important}.calendar-day__next[data-v-b0ffa14a],.calendar-day__prev[data-v-b0ffa14a]{top:70px;margin-top:-16px;display:block;position:absolute;width:32px;height:32px;border:3px solid #fff;background-color:rgba(110,107,206,.7);border-radius:16px;color:#fff;transition:background-color .2s ease-in-out;background-position:50%;background-repeat:no-repeat}.calendar-day__next[data-v-b0ffa14a]:hover,.calendar-day__prev[data-v-b0ffa14a]:hover{background-color:#6e6bce}.calendar-day__next[data-v-b0ffa14a]{right:-16px;background-image:url(" + escape(require("./r.png")) + ")}.calendar-day__prev[data-v-b0ffa14a]{left:-16px;background-image:url(" + escape(require("./l.png")) + ")}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b0ffa14a","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./src/components/calendar/day/styles.styl
// module id = 3dc96b8f71c6c59ba738
// module chunks = 13